/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { useI18nFormatters } from 'hooks/i18nFormatters';

const RecordHeader = ({ record }) => {
  const { i18nFormatDateOnly } = useI18nFormatters();

  return (
    <Row className="pdd-vertical-20">
      <Col span={16}>{record.label}</Col>
      <Col span={4}>{i18nFormatDateOnly(record.acquisitionDate, 1)}</Col>
      <Col span={4}>{i18nFormatDateOnly(record.publicationDate, 1)}</Col>
    </Row>
  );
};

export default RecordHeader;

RecordHeader.propTypes = {
  record: PropTypes.any.isRequired,
};
